var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "class-page" },
    [
      _c("ClassPageHeader", {
        attrs: {
          details: _vm.details,
          "current-section": parseInt(_vm.sectionId),
          "course-content": _vm.courseContent,
          course: _vm.course,
          menu: _vm.menu,
          "is-class-item-page": true
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "back-link" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.goToClassPage()
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-caret-left",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t"
            )
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "glossary" },
            [
              _c("glossary-index", {
                attrs: { terms: _vm.termList },
                on: { setFilterByValues: _vm.setFilterBy }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "glossary-body" },
                [
                  _vm.glossary.ALLOW_STUDENT_ENTRY_FLG === "Y" &&
                  _vm.role === "student"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary new-btn",
                          attrs: { disabled: _vm.showForm },
                          on: { click: _vm.openForm }
                        },
                        [
                          _c("i", { staticClass: "fas fa-plus" }),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.commonContent.newEntryTitleCase"
                                )
                              ) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.glossary.ENTRIES && _vm.glossary.ENTRIES.length
                    ? _c("glossary-search", {
                        attrs: {
                          total: _vm.glossary.ENTRIES.length,
                          searchQuery: _vm.searchText
                        },
                        on: {
                          updateSearch: _vm.updateSearchText,
                          showAll: _vm.showAllEntries,
                          hideAll: _vm.hideAllEntries
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showForm
                    ? _c("glossary-form", {
                        attrs: { type: _vm.glossaryType() },
                        on: { closeForm: _vm.closeFormReload }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("glossary-results", {
                    attrs: {
                      entries: _vm.filteredGlossary,
                      type: _vm.glossaryType(),
                      canEdit: _vm.glossary.ALLOW_STUDENT_ENTRY_FLG === "Y"
                    },
                    on: {
                      clearResults: _vm.clearResults,
                      clearTerm: _vm.clearTerm
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "back-link" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.goToClassPage()
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-caret-left",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t"
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }